// Emailjs functions for sending notification emails

import emailjs from "@emailjs/browser";

const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "publicKeyPlaceholder";
const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "serviceIDPlaceholder";
const ContactTemplateID = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID || "contactTemplateIDPlaceholder";
const SupportTemplateID = process.env.REACT_APP_EMAILJS_SUPPORT_TEMPLATE_ID || "supportTemplateIDPlaceholder";

export async function sendContactNotification(formData) {
  try {
    const result = await emailjs.send(serviceID, ContactTemplateID, formData, {
      publicKey,
    });
    return result;
  } catch (error) {
    console.error("Error sending contact notification:", error);
    throw error;
  }
}

export async function sendSupportNotification(params) {
  try {
    const result = await emailjs.send(serviceID, SupportTemplateID, params, {
      publicKey,
    });
    return result;
  } catch (error) {
    console.error("Error sending support notification:", error);
    return error;
  }
};
